const WORK_CASES = [
  {
    id: "droneAgri",
    image: "droneAgri",
    tag: { ja: "自社ドローン × 農業", en: "In-house drone × agriculture" },
    title: {
      ja: "自律探索ドローンによる空撮と分布マップのPoC",
      en: "PoC: autonomous scouting, aerials, distribution maps",
    },
    desc: {
      ja: "自社開発の画像認識搭載ドローンで圃場上空を自律走行。GPSと空撮データを連携し、病害虫の分布をマップ化する一連の検証を、ハード・ソフト一体で実施しました。",
      en: "Our in-house vision-guided drone autonomously scanned fields—linking GPS and aerial capture to validate distribution-map analytics as one hardware–software stack.",
    },
    highlights: [
      { ja: "圃場走査ルートの自動生成とリアルタイム位置同期", en: "Auto-generated flight paths with live GPS sync" },
      { ja: "空撮画像から分布ヒートマップを生成する解析パイプライン", en: "Analytics pipeline turning aerials into distribution heatmaps" },
      { ja: "農業現場のオペレーターが使えるダッシュボードまで実装", en: "Operator-ready dashboards for field teams" },
    ],
  },
  {
    id: "disasterWaste",
    image: "disasterWaste",
    tag: { ja: "防災 × 予測AI", en: "Resilience × predictive AI" },
    title: {
      ja: "災害廃棄物の発生量・設置・処理フローを高精度に推定",
      en: "Forecasting disaster waste volumes, placement, and flows",
    },
    desc: {
      ja: "自治体のオープンデータ、都市計画、地図情報を横断統合。被災シナリオごとに廃棄物の発生量と処理拠点の配置をシミュレーションし、現場判断を支える可視化基盤を構築しました。",
      en: "We fused civic open data, urban planning, and mapping layers to simulate waste volumes and depot placement per disaster scenario—shipping dashboards operators actually use.",
    },
    highlights: [
      { ja: "複数自治体データのクレンジングと統合スキーマ設計", en: "Cleansing and unified schemas across municipal datasets" },
      { ja: "被災パターン別の発生量シミュレーションエンジン", en: "Scenario-level volume simulation engine" },
      { ja: "処理拠点の配置と搬送フローを一望できるマップUI", en: "Map UI surfacing depot placement and haul routes" },
    ],
  },
  {
    id: "pricingAi",
    image: "pricingAi",
    tag: { ja: "越境EC × 価格AI", en: "Cross-border commerce × pricing AI" },
    title: {
      ja: "グローバル買取・販売データの収集基盤と価格予測モデル",
      en: "Global pricing intelligence on a living dataset",
    },
    desc: {
      ja: "複数国・複数マーケットプレイスから価格データを常時収集するデータレイクを構築。学習パイプラインと推論APIを一体で設計し、相場変動に追従する予測機能をプロダクトに組み込みました。",
      en: "Built an always-on data lake ingesting prices across countries and marketplaces—training loops and inference APIs embedded in the product so forecasts track live markets.",
    },
    highlights: [
      { ja: "24時間稼働のクローラーと品質チェック付きデータレイク", en: "24/7 crawlers with quality-gated data lake ingestion" },
      { ja: "相場トレンドを反映する再学習パイプライン", en: "Retraining pipelines that follow market trends" },
      { ja: "買取・販売判断を支援する予測APIのプロダクト統合", en: "Forecast APIs wired into buy/sell decision workflows" },
    ],
  },
  {
    id: "ragChat",
    image: "ragChat",
    tag: { ja: "生成AI × 社内ナレッジ", en: "GenAI × enterprise knowledge" },
    title: {
      ja: "RAGとLLMを組み合わせたエンタープライズチャット",
      en: "Enterprise chat blending RAG with LLMs",
    },
    desc: {
      ja: "社内規程・マニュアル・過去案件のドキュメントを安全に検索し、根拠付きで回答するチャットを構築。検索と生成を分離したアーキテクチャで、運用コストとハルシネーションリスクを抑えました。",
      en: "Grounded chat over policies, manuals, and past engagements—retrieval and generation decoupled to tame ops cost and hallucination risk.",
    },
    highlights: [
      { ja: "アクセス権限を踏まえたドキュメントインデックス設計", en: "Permission-aware document indexing" },
      { ja: "引用元を明示する根拠付き回答UI", en: "Answers with explicit source citations" },
      { ja: "プロンプト・インデックス更新の運用フロー整備", en: "Ops playbooks for prompt and index refresh" },
    ],
  },
  {
    id: "safetyNlp",
    image: "safetyNlp",
    tag: { ja: "建設安全 × NLP", en: "Construction safety × NLP" },
    title: {
      ja: "数万件規模の災害事例テキストを自動分類・類似検索",
      en: "Classifying & surfacing patterns across tens of thousands of incident narratives",
    },
    desc: {
      ja: "厚労省などが公開する大量の災害報告文書を機械学習でタグ付け・分類。類似災害を瞬時に検索できるナレッジベースへ変換し、建設現場の安全計画に活かせる形で提供しました。",
      en: "Tagged and classified massive regulatory incident corpora—turning free-text reports into a similar-case knowledge base for proactive safety planning on site.",
    },
    highlights: [
      { ja: "日本語災害報告文の多ラベル自動分類モデル", en: "Multi-label classifiers for Japanese incident narratives" },
      { ja: "類似事例を秒単位で引くベクトル検索基盤", en: "Vector search surfacing similar cases in seconds" },
      { ja: "安全担当者向けの検索・フィルタUI", en: "Search and filter UI built for safety officers" },
    ],
  },
  {
    id: "energyForecast",
    image: "energyForecast",
    tag: { ja: "エネルギー × 需要予測", en: "Energy × demand forecasting" },
    title: {
      ja: "多変量ビッグデータを用いた電力需要予測と劣化しにくい学習基盤",
      en: "Robust power-demand forecasting on heterogeneous big data",
    },
    desc: {
      ja: "気象・需要・再エネ出力など複数時系列を統合した需要予測モデルを開発。モデル劣化を検知するモニタリングと再学習設計を一体で整備し、長期運用を見据えたMLOps基盤を構築しました。",
      en: "Fused weather, demand, and renewables signals into forecasting models—with drift monitoring and retraining designed for long-run MLOps.",
    },
    highlights: [
      { ja: "気象・需要・再エネの多系列特徴エンジニアリング", en: "Multi-series features across weather, demand, and renewables" },
      { ja: "予測精度のドリフト検知とアラート設計", en: "Drift detection and alerting on forecast accuracy" },
      { ja: "定期再学習を回すクラウド上の学習パイプライン", en: "Cloud training pipelines for scheduled refresh" },
    ],
  },
  {
    id: "receiptOcr",
    image: "receiptOcr",
    tag: { ja: "消費財 × OCR", en: "Consumer goods × OCR" },
    title: {
      ja: "レシート画像からの検知・認識・構造化パイプライン",
      en: "Detection, recognition, structuring for receipt imagery",
    },
    desc: {
      ja: "スマホ撮影されたレシート画像から商品・金額・店舗情報を自動抽出。検知→OCR→構造化の3段パイプラインと人的確認フローを組み合わせ、マーケティング調査の転記工数を大幅に削減しました。",
      en: "Auto-extracted items, amounts, and store metadata from phone-captured receipts—detect → OCR → structure with human-in-the-loop QA, slashing transcription load for insight programs.",
    },
    highlights: [
      { ja: "撮影ブレ・影に強いレシート領域の自動検出", en: "Robust receipt-region detection despite blur and shadow" },
      { ja: "キー項目の構造化JSON出力と精度スコアリング", en: "Structured JSON output with per-field confidence" },
      { ja: "低信頼データだけを人が確認するレビュー画面", en: "Review UI routing only low-confidence rows to humans" },
    ],
  },
]
